module.exports = __webpack_public_path__ + "static/media/12.c0d546d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kenya/12.jpg
// module id = 488
// module chunks = 0